<template>
  <div
    class="d-flex flex-column"
    :class="
      item.url_midia_colaboracao && !isFullScreen ? 'mb-14' : !isFullScreen ? 'mb-10' : ''
    "
    :style="cardStyle"
    :key="item.id_colaboracao"
  >
    <header
      v-if="
        !hideUserInfo &&
        !(
          item.url_midia_colaboracao &&
          item.dsc_texto_colaboracao &&
          item.flg_exibir_texto &&
          midiaOrientation === 'vertical' &&
          !isFullScreen
        )
      "
      class="d-flex flex-wrap-1 py-1"
      :class="
        configCores.dsc_nome_config !== 'Background Nacional 2025' ? 'px-2' : 'mb-1'
      "
      :style="backgroundHeaderImg"
    >
      <!-- <div
        v-if="configCores.dsc_nome_config === 'Background Nacional 2025'"
        style="height: 100%; width: auto"
        class="mr-1"
      >
        <v-img
          :src="avatarColaborador"
          :width="isFullScreen ? '60' : '48'"
          :height="isFullScreen ? '60' : '48'"
        ></v-img>
      </div> -->
      <!-- <v-icon
        v-if="configCores.dsc_nome_config !== 'Background Nacional 2025'"
        size="42"
        class="ma-0 pa-0 px-1"
        :style="{ textShadow: `0 0 5px ${backgroundColor}` }"
        color="white"
        style="transform: scaleX(-1)"
      >
        {{
          configCores.dsc_nome_config === "Background Nacional 2025"
            ? "mdi-chat-outline"
            : "mdi-chat"
        }}
      </v-icon> -->
      <!-- <img class="ma-0 pa-1" height="40" width="40" src="@/assets/chat2.png" /> -->
      <div
        class="d-flex align-center justify-self-start align-self-center"
        style="height: 100%"
      >
        <span
          class="text-uppercase ml-4"
          style="font-size: 1.2rem; font-weight: 600; font-family: Globotipo !important"
          :style="{
            color: configCores.dsc_hex_cor_header,
          }"
          :class="isFullScreen ? 'text-h4' : 'text-h5'"
        >
          <template v-if="flg_exibir_uf && item.dsc_uf_colaborador">
            {{ `${item.dsc_nome_colaborador} - ${item.dsc_uf_colaborador}` }}
          </template>
          <template v-else>
            {{ item.dsc_nome_colaborador }}
          </template>
        </span>
      </div>
      <!-- <div
        class="d-flex align-center justify-end flex-grow-1"
        :style="{ background: configCores.dsc_hex_cor_header }"
      >
        <v-icon
          v-if="configCores.dsc_nome_config === 'Background Nacional 2025'"
          size="42"
          class="ma-0 pa-0 px-1"
          :style="{ textShadow: `0 0 5px ${backgroundColor}` }"
          color="white"
          style="transform: scaleX(-1); margin-left: auto"
        >
          {{
            configCores.dsc_nome_config === "Background Nacional 2025"
              ? "mdi-chat-outline"
              : "mdi-chat"
          }}
        </v-icon>
      </div> -->
    </header>
    <section class="d-flex align-center flex-grow-1">
      <div
        v-if="renderMode === 'text'"
        v-html="item.dsc_texto_colaboracao"
        class="px-3 py-3 font-weight-normal colab-text"
        style="font-family: Globotipo !important"
        :style="{ lineHeight: lineHeight, fontSize: bodyTextSize, color: bodyTextColor }"
      ></div>
      <div
        v-else-if="renderMode === 'texto_fullscreen'"
        v-html="item.dsc_texto_colaboracao"
        class="px-3 py-3 font-weight-normal"
        style="font-family: Globotipo !important"
        :style="{
          lineHeight: lineHeightFullScreen,
          fontSize: bodyTextSizeFullSreen,
          wordBreak: 'break-word',
          color: bodyTextColor,
        }"
      ></div>
      <div
        v-else-if="renderMode === 'audio'"
        style="width: 100%"
        class="d-flex align-center align-self-center justify-center px-8"
      >
        <audio
          controls
          controlslist="nodownload"
          autoplay
          style="width: 100%"
          :key="item.url_midia_colaboracao"
        >
          <source :src="item.url_midia_colaboracao" />
        </audio>
      </div>
      <div
        v-else-if="renderMode === 'midia'"
        :style="
          item.dsc_tipo_midia_colaboracao === 'image'
            ? 'width: 100%;'
            : 'width: 100%; display: grid; grid-template-columns: 1fr;'
        "
        :class="
          item.dsc_tipo_midia_colaboracao === 'image'
            ? 'd-flex align-center justify-center pa-2'
            : 'pa-2'
        "
        :id="`${item.id_colaboracao}-wrapper`"
      >
        <img
          v-if="item.dsc_tipo_midia_colaboracao === 'image'"
          :id="`${item.id_colaboracao}`"
          :src="item.url_midia_colaboracao"
          :style="
            isFullScreen
              ? `max-width: ${
                  (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) / 100
                }px;
                                            min-width: ${
                                              (percentScreenDim.fullScreenMinWidth *
                                                screenDimensions.width) /
                                              100
                                            }px;
                                            max-height: ${
                                              (percentScreenDim.fullScreenMaxHeight *
                                                screenDimensions.height) /
                                              100
                                            }px;
                                            min-height: ${
                                              (percentScreenDim.fullScreenMinHeight *
                                                screenDimensions.height) /
                                              100
                                            }px;`
              : `max-width: ${
                  (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                }px; 
                                            max-height: ${
                                              (percentScreenDim.maxHeight *
                                                screenDimensions.height) /
                                                100 -
                                              100
                                            }px`
          "
        />
        <video
          v-if="item.dsc_tipo_midia_colaboracao === 'video'"
          autoplay
          :id="`${item.id_colaboracao}`"
          :key="item.url_midia_colaboracao"
          style="justify-self: center"
          :style="
            isFullScreen
              ? `max-height: ${
                  (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) / 100
                }px; 
                                            max-width: ${
                                              (percentScreenDim.fullScreenMaxWidth *
                                                screenDimensions.width) /
                                              100
                                            }px`
              : `max-width: 100%;
                                            max-height: ${
                                              (percentScreenDim.maxHeight *
                                                screenDimensions.height) /
                                                100 -
                                              100
                                            }px`
          "
        >
          <source :src="item.url_midia_colaboracao" />
        </video>
      </div>
      <div
        v-else-if="renderMode === 'midia_texto_fullscreen'"
        :style="
          item.dsc_tipo_midia_colaboracao === 'image'
            ? 'width: 100%;'
            : 'width: 100%; display: grid; grid-template-columns: 1fr;'
        "
        :class="
          item.dsc_tipo_midia_colaboracao === 'image'
            ? 'd-flex align-center justify-center pa-2'
            : 'pa-2'
        "
      >
        <div
          v-if="midiaOrientation && midiaOrientation === 'horizontal'"
          class="d-flex flex-column align-center align-center"
        >
          <img
            v-if="item.dsc_tipo_midia_colaboracao === 'image'"
            :src="item.url_midia_colaboracao"
            :style="
              isFullScreen
                ? `max-width: ${
                    (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) / 100
                  }px;
                                                max-height: ${
                                                  (percentScreenDim.fullScreenMaxHeight *
                                                    screenDimensions.height) /
                                                    100 -
                                                  50
                                                }px;
                                                min-height: ${
                                                  (percentScreenDim.fullScreenMinHeight *
                                                    screenDimensions.height) /
                                                  100
                                                }px;`
                : `max-width: ${
                    (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                  }px; 
                                max-height: ${
                                  (percentScreenDim.maxHeight * screenDimensions.height) /
                                    100 -
                                  50
                                }px`
            "
          />
          <video
            v-if="item.dsc_tipo_midia_colaboracao === 'video'"
            autoplay
            :id="`${item.id_colaboracao}`"
            :key="item.url_midia_colaboracao"
            style="justify-self: center"
            :style="
              isFullScreen
                ? `max-height: ${
                    (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) / 100
                  }px; 
                                                max-width: ${
                                                  (percentScreenDim.fullScreenMaxWidth *
                                                    screenDimensions.width) /
                                                  100
                                                }px`
                : `max-width: ${
                    (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                  }px; 
                                                max-height: ${
                                                  (percentScreenDim.maxHeight *
                                                    screenDimensions.height) /
                                                    100 -
                                                  50
                                                }px`
            "
          >
            <source :src="item.url_midia_colaboracao" />
          </video>
          <div
            v-html="item.dsc_texto_colaboracao"
            class="px-3 py-3 font-weight-normal"
            style="font-family: Globotipo !important"
            :style="{
              lineHeight: lineHeightFullScreen,
              fontSize: bodyTextSizeFullSreen,
              wordBreak: 'break-word',
              color: bodyTextColor,
            }"
          ></div>
        </div>
        <div
          v-else-if="midiaOrientation && midiaOrientation === 'vertical'"
          class="d-flex align-center justify-center"
        >
          <div class="pa-2 d-flex" :style="{ backgroundColor: backgroundColor }">
            <img
              v-if="item.dsc_tipo_midia_colaboracao === 'image'"
              :src="item.url_midia_colaboracao"
              :style="
                isFullScreen
                  ? `max-width: ${
                      (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) / 100
                    }px;
                                                    max-height: ${
                                                      (percentScreenDim.fullScreenMaxHeight +
                                                        10 * screenDimensions.height) /
                                                      100
                                                    }px;
                                                    min-height: ${
                                                      (percentScreenDim.fullScreenMinHeight *
                                                        screenDimensions.height) /
                                                      100
                                                    }px;`
                  : `max-width: ${
                      (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                    }px; 
                                                    max-height: ${
                                                      (percentScreenDim.maxHeight *
                                                        screenDimensions.height) /
                                                        100 -
                                                      50
                                                    }px`
              "
            />
            <video
              v-if="item.dsc_tipo_midia_colaboracao === 'video'"
              autoplay
              :id="`${item.id_colaboracao}`"
              :key="item.url_midia_colaboracao"
              style="justify-self: center"
              :style="
                isFullScreen
                  ? `max-height: ${
                      (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) /
                      100
                    }px; 
                                                                                                        max-width: ${
                                                                                                          (percentScreenDim.fullScreenMaxWidth *
                                                                                                            screenDimensions.width) /
                                                                                                          100
                                                                                                        }px`
                  : `max-width: ${
                      (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                    }px; 
                                                                                                        max-height: ${
                                                                                                          (percentScreenDim.maxHeight *
                                                                                                            screenDimensions.height) /
                                                                                                            100 -
                                                                                                          50
                                                                                                        }px`
              "
            >
              <source :src="item.url_midia_colaboracao" />
            </video>
            <div
              v-html="item.dsc_texto_colaboracao"
              class="px-3 py-3 font-weight-normal"
              style="font-family: Globotipo !important"
              :style="{
                lineHeight: lineHeightFullScreen,
                fontSize: bodyTextSizeFullSreen,
                wordBreak: 'break-word',
                color: bodyTextColor,
              }"
            ></div>
          </div>
        </div>
      </div>
      <div
        v-else-if="renderMode === 'midia_texto'"
        :style="
          configCores.dsc_nome_config === 'Background Nacional 2025' &&
          midiaOrientation === 'horizontal'
            ? { background: backgroundColor }
            : item.dsc_tipo_midia_colaboracao === 'image'
            ? 'width: 100%;'
            : 'width: 100%; display: grid; grid-template-columns: 1fr;'
        "
        :class="
          item.dsc_tipo_midia_colaboracao === 'image' && midiaOrientation === 'horizontal'
            ? 'd-flex align-center justify-center pa-2'
            : item.dsc_tipo_midia_colaboracao === 'video' &&
              midiaOrientation === 'horizontal'
            ? 'pa-2'
            : ''
        "
      >
        <div
          v-if="midiaOrientation && midiaOrientation === 'horizontal'"
          class="d-flex flex-column align-center"
        >
          <img
            v-if="item.dsc_tipo_midia_colaboracao === 'image'"
            id="image"
            :src="item.url_midia_colaboracao"
            :style="
              isFullScreen
                ? `max-width: ${
                    (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) / 100
                  }px;
                                            min-width: ${
                                              (percentScreenDim.fullScreenMinWidth *
                                                screenDimensions.width) /
                                              100
                                            }px;
                                            max-height: ${
                                              (percentScreenDim.fullScreenMaxHeight *
                                                screenDimensions.height) /
                                              100
                                            }px;
                                            min-height: ${
                                              (percentScreenDim.fullScreenMinHeight *
                                                screenDimensions.height) /
                                              100
                                            }px;`
                : `max-width: ${
                    (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                  }px;
                                            max-height: ${
                                              (percentScreenDim.maxHeight *
                                                screenDimensions.height) /
                                                100 -
                                              100
                                            }px`
            "
          />
          <video
            v-else-if="item.dsc_tipo_midia_colaboracao === 'video'"
            autoplay
            :id="`${item.id_colaboracao}`"
            :key="item.url_midia_colaboracao"
            style="justify-self: center"
            :style="
              isFullScreen
                ? `max-height: ${
                    (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) / 100
                  }px; 
                                                max-width: ${
                                                  (percentScreenDim.fullScreenMaxWidth *
                                                    screenDimensions.width) /
                                                  100
                                                }px`
                : `max-width: ${
                    (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                  }px; 
                                            max-height: ${
                                              (percentScreenDim.maxHeight *
                                                screenDimensions.height) /
                                                100 -
                                              50
                                            }px`
            "
          >
            <source :src="item.url_midia_colaboracao" />
          </video>
          <div
            v-html="item.dsc_texto_colaboracao"
            class="px-3 py-3 font-weight-normal colab-text"
            style="font-family: Globotipo !important"
            :style="{
              lineHeight: lineHeight,
              fontSize: bodyTextSize,
              color: bodyTextColor,
            }"
          ></div>
        </div>
        <div
          v-else-if="midiaOrientation && midiaOrientation === 'vertical'"
          class="d-flex"
        >
          <div class="pa-2" :style="{ backgroundColor: backgroundColor }">
            <img
              v-if="item.dsc_tipo_midia_colaboracao === 'image'"
              id="image"
              :src="item.url_midia_colaboracao"
              :style="
                isFullScreen
                  ? `max-width: ${
                      (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) / 100
                    }px;
                                                min-width: ${
                                                  (percentScreenDim.fullScreenMinWidth *
                                                    screenDimensions.width) /
                                                  100
                                                }px;
                                                max-height: ${
                                                  (percentScreenDim.fullScreenMaxHeight *
                                                    screenDimensions.height) /
                                                  100
                                                }px;
                                                min-height: ${
                                                  (percentScreenDim.fullScreenMinHeight *
                                                    screenDimensions.height) /
                                                  100
                                                }px;`
                  : `max-width: ${
                      (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                    }px; 
                                                max-height: ${
                                                  (percentScreenDim.maxHeight *
                                                    screenDimensions.height) /
                                                    100 -
                                                  50
                                                }px`
              "
            />
            <video
              v-else-if="item.dsc_tipo_midia_colaboracao === 'video'"
              autoplay
              :id="`${item.id_colaboracao}`"
              :key="item.url_midia_colaboracao"
              style="justify-self: center"
              :style="
                isFullScreen
                  ? `max-height: ${
                      (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) /
                      100
                    }px; 
                                                    max-width: ${
                                                      (percentScreenDim.fullScreenMaxWidth *
                                                        screenDimensions.width) /
                                                      100
                                                    }px`
                  : `max-width: 100%; 
                                                    max-height: ${
                                                      (percentScreenDim.maxHeight *
                                                        screenDimensions.height) /
                                                        100 -
                                                      50
                                                    }px`
              "
            >
              <source :src="item.url_midia_colaboracao" />
            </video>
          </div>
          <div
            class="d-flex flex-column align-self-end"
            style="min-height: 160px; max-height: 180px"
            :style="
              configCores.dsc_nome_config === 'Background Nacional 2025'
                ? `max-width: ${(33.5 * screenDimensions.width) / 100}px;
                                min-width: ${(33.5 * screenDimensions.width) / 100}px;`
                : `max-width: ${(33.5 * screenDimensions.width) / 100}px;
                                min-width: ${
                                  (33.5 * screenDimensions.width) / 100
                                }px; background-color: ${backgroundColor}`
            "
          >
            <header
              v-if="
                !hideUserInfo &&
                item.url_midia_colaboracao &&
                item.dsc_texto_colaboracao &&
                midiaOrientation === 'vertical'
              "
              class="d-flex flex-wrap-1 py-1"
              :style="backgroundHeaderImg"
            >
              <!-- <div
                v-if="configCores.dsc_nome_config === 'Background Nacional 2025'"
                style="height: 100%; width: auto"
                class="mr-1"
              >
                <v-img
                  :src="avatarColaborador"
                  :width="isFullScreen ? '60' : '48'"
                  :height="isFullScreen ? '60' : '48'"
                ></v-img>
              </div> -->
              <!-- <v-icon
                v-if="configCores.dsc_nome_config !== 'Background Nacional 2025'"
                size="42"
                class="ma-0 pa-0 ml-1"
                :style="{ textShadow: `0 0 5px ${backgroundColor}` }"
                color="white"
                style="transform: scaleX(-1)"
              >
                mdi-chat
              </v-icon> -->
              <div
                class="d-flex align-center justify-self-start align-self-center"
                style="height: 100%"
              >
                <span
                  class="text-uppercase ml-2"
                  :style="{
                    color: configCores.dsc_hex_cor_header,
                  }"
                  style="font-weight: 600"
                  :class="isFullScreen ? 'text-h4' : 'text-h5'"
                >
                  <template v-if="flg_exibir_uf && item.dsc_uf_colaborador">
                    {{ `${item.dsc_nome_colaborador} - ${item.dsc_uf_colaborador}` }}
                  </template>
                  <template v-else>
                    {{ item.dsc_nome_colaborador }}
                  </template>
                </span>
              </div>
              <!-- <div
                class="d-flex align-center justify-end flex-grow-1"
                :style="{ background: configCores.dsc_hex_cor_header }"
              >
                <v-icon
                  v-if="configCores.dsc_nome_config === 'Background Nacional 2025'"
                  size="42"
                  class="ma-0 pa-0 px-1"
                  :style="{ textShadow: `0 0 5px ${backgroundColor}` }"
                  color="white"
                  style="transform: scaleX(-1); margin-left: auto"
                >
                  {{
                    configCores.dsc_nome_config === "Background Nacional 2025"
                      ? "mdi-chat-outline"
                      : "mdi-chat"
                  }}
                </v-icon>
              </div> -->
            </header>
            <div
              v-html="item.dsc_texto_colaboracao"
              style="font-family: Globotipo !important"
              class="px-3 py-3 font-weight-normal d-flex align-center align-self-center colab-text"
              :style="{
                lineHeight: lineHeight,
                fontSize: bodyTextSize,
                color: bodyTextColor,
              }"
            ></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
const defaultUserProfilePhoto = require("../../assets/User.png");
const backgroundHeader = require("@/assets/tarjas/bg-header-tarja-big-pool-day.png");
const backgroundHeaderBMX = require("@/assets/tarjas/bg-header-tarja-bmx-ee.png");
export default {
  props: {
    item: Object,
    posicaoCard: String,
    isFullScreen: Boolean,
    hideUserInfo: Boolean,
    flg_exibir_uf: Boolean,
    configCores: Object,
  },
  data() {
    return {
      midiaOrientation: null,
      midiaDimension: {},
      divMidiaWrapperDimension: null,
      percentScreenDim: {
        // porcentagem da tela que a div irá ocupar
        maxWidth: 40,
        minWidth: 20,
        minHeight: 40,
        maxHeight: 70,
        fullScreenMaxWidth: 60,
        fullScreenMaxHeight: 80,
        fullScreenMinWidth: 30,
        fullScreenMinHeight: 50,
      },
    };
  },
  created() {
    if (this.item.url_midia_colaboracao) {
      this.getMidiaOrientation();
    }
  },
  computed: {
    renderMode() {
      if (
        this.item.dsc_tipo_midia_colaboracao &&
        this.item.dsc_tipo_midia_colaboracao === "audio"
      ) {
        return "audio";
      } else if (
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        (!this.item.dsc_texto_colaboracao || !this.item.flg_exibir_texto)
      ) {
        return "midia";
      } else if (
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        this.item.dsc_texto_colaboracao &&
        this.isFullScreen
      ) {
        return "midia_texto_fullscreen";
      } else if (
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        this.item.flg_exibir_texto &&
        this.item.dsc_texto_colaboracao &&
        !this.isFullScreen
      ) {
        return "midia_texto";
      } else if (
        this.item.dsc_texto_colaboracao &&
        this.isFullScreen &&
        !this.url_midia_colaboracao
      ) {
        return "texto_fullscreen";
      }
      return "text";
    },
    bodyTextSize() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const size =
        (numChars > 0) & (numChars <= 40)
          ? "2.1rem"
          : numChars > 40 && numChars <= 80
          ? "2rem"
          : numChars > 80 && numChars <= 120
          ? "1.7rem"
          : numChars > 120 && numChars <= 160
          ? "1.6rem"
          : numChars > 160 && numChars <= 200
          ? "1.5rem"
          : numChars > 200 && numChars <= 240
          ? "1.3rem"
          : numChars > 240 && numChars <= 280
          ? "1.2rem"
          : "1.5rem";
      return size;
    },
    lineHeight() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "2.2rem"
          : numChars > 40 && numChars <= 80
          ? "2rem"
          : numChars > 80 && numChars <= 120
          ? "1.75rem"
          : numChars > 120 && numChars <= 160
          ? "1.65rem"
          : numChars > 160 && numChars <= 200
          ? "1.6rem"
          : numChars > 200 && numChars <= 240
          ? "1.5rem"
          : numChars > 240 && numChars <= 280
          ? "1.45rem"
          : "1.5rem";

      return lineHeight;
    },
    bodyTextSizeFullSreen() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const size =
        (numChars > 0) & (numChars <= 40)
          ? "3rem"
          : numChars > 40 && numChars <= 80
          ? "2.7rem"
          : numChars > 80 && numChars <= 120
          ? "2.5rem"
          : numChars > 120 && numChars <= 160
          ? "2.4rem"
          : numChars > 160 && numChars <= 200
          ? "2.2rem"
          : numChars > 200 && numChars <= 240
          ? "2.1rem"
          : numChars > 240 && numChars <= 280
          ? "2.5rem"
          : "1.5rem";
      return size;
    },
    lineHeightFullScreen() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "3rem"
          : numChars > 40 && numChars <= 80
          ? "2.8rem"
          : numChars > 80 && numChars <= 120
          ? "2.6rem"
          : numChars > 120 && numChars <= 160
          ? "2.5rem"
          : numChars > 160 && numChars <= 200
          ? "2.4rem"
          : numChars > 200 && numChars <= 240
          ? "2.3rem"
          : numChars > 240 && numChars <= 280
          ? "2.8rem"
          : "1.5rem";

      return lineHeight;
    },
    screenDimensions() {
      return {
        width: this.$vuetify.breakpoint.width,
        height: this.$vuetify.breakpoint.height,
      };
    },
    backgroundColor() {
      return this.configCores.dsc_hex_cor_background;
    },
    bodyTextColor() {
      return this.configCores.dsc_hex_cor_texto;
    },
    headerInfoColor() {
      return {
        background:
          this.configCores.dsc_nome_config !== "Background Nacional 2025"
            ? this.configCores.dsc_hex_cor_header
            : "",
      };
    },
    avatarColaborador() {
      return this.item.url_avatar_colaborador && this.item.flg_sem_avatar === "N"
        ? this.item.url_avatar_colaborador
        : defaultUserProfilePhoto;
    },
    backgroundHeaderImg() {
      const bgUrl = this.configCores.dsc_nome_config.includes("BMX")
        ? backgroundHeaderBMX
        : backgroundHeader;
      return {
        backgroundImage: `url(${bgUrl})`,
        backgroundRepeat: "repeat-x",
        backgroundSize: "cover",
        backgroundPosition: "center",
      };
    },
    cardStyle() {
      let maxWidth, maxHeight, minWidth, minHeight;
      if (this.isFullScreen) {
        minWidth =
          (this.percentScreenDim.fullScreenMinWidth * this.screenDimensions.width) / 100; // 20% of screen width + 20px
        maxWidth =
          (this.percentScreenDim.fullScreenMaxWidth * this.screenDimensions.width) / 100 +
          20; // 60% of screen width + 20px
        minHeight =
          (this.percentScreenDim.fullScreenMinHeight * this.screenDimensions.height) /
          100; // 60% of screen height + 50px
        maxHeight =
          (this.percentScreenDim.fullScreenMaxHeight * this.screenDimensions.height) /
            100 +
          50; // 80% of screen height + 50px
        if (this.renderMode === "texto_fullscreen") {
          minWidth =
            (this.percentScreenDim.fullScreenMinWidth -
              10 * this.screenDimensions.width) /
            100;
          minHeight =
            (this.percentScreenDim.fullScreenMinHeight -
              30 * this.screenDimensions.height) /
            100;
        }
        const backgroundStyle = `background-color: ${this.backgroundColor}`;
        const fullScreenStyle = `justify-self: center; max-width: ${maxWidth}px !important; max-height: ${maxHeight}px !important;
                                         min-width: ${minWidth}px !important; min-height: ${minHeight}px !important;`;

        return this.configCores.dsc_nome_config === "Background Nacional 2025"
          ? fullScreenStyle
          : fullScreenStyle + backgroundStyle;
      }
      const position =
        this.posicaoCard === "esquerda" && !this.item.url_midia_colaboracao
          ? "margin-left: 100px; justify-self: flex-start"
          : this.posicaoCard === "centro"
          ? "justify-self: center"
          : this.posicaoCard === "direita" && !this.item.url_midia_colaboracao
          ? "margin-right: 40px; justify-self: flex-end"
          : this.posicaoCard === "direita" && this.item.url_midia_colaboracao
          ? "margin-right: 60px; justify-self: flex-start"
          : this.posicaoCard === "esquerda" && this.item.url_midia_colaboracao
          ? "margin-left: 120px; justify-self: flex-start"
          : "";

      // regras para visualização normal, sem modo tela cheia
      maxWidth = (this.percentScreenDim.maxWidth * this.screenDimensions.width) / 100; // 40% of screen width
      maxHeight = (this.percentScreenDim.maxHeight * this.screenDimensions.height) / 100; // 80% of screen height
      // const textMaxWidth = (33.5 * this.screenDimensions.width) / 100; // 40% of screen width
      // const textMaxHeight = (15.5 * this.screenDimensions.height) / 100; // 20% of screen height)
      const dimensions =
        ["video", "image"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        !this.item.dsc_texto_colaboracao
          ? `max-width: ${maxWidth}px; max-height: ${maxHeight}px !important;`
          : this.item.url_midia_colaboracao &&
            this.item.dsc_texto_colaboracao &&
            this.midiaOrientation === "horizontal"
          ? `max-width: ${maxWidth}px; max-height: ${maxHeight}px !important;`
          : this.item.url_midia_colaboracao &&
            this.item.dsc_texto_colaboracao &&
            this.midiaOrientation === "vertical"
          ? `max-width: auto !important; max-height: ${maxHeight}px !important;`
          : `width: 640px; height: 160px;`;

      const backgroundStyle = `background-color: ${this.backgroundColor};`;
      let array = position
        .split(";")
        .concat(dimensions.split(";"))
        .filter((item) => item != "");
      if (
        (this.renderMode !== "midia_texto" ||
          (this.renderMode === "midia_texto" && this.midiaOrientation !== "vertical")) &&
        this.configCores.dsc_nome_config !== "Background Nacional 2025"
      ) {
        array.push(backgroundStyle);
      }
      return array.filter((item) => item).join(";");
    },
  },
  methods: {
    getDivMidiaWrapperDimension() {
      if (
        this.item.url_midia_colaboracao &&
        this.item.dsc_tipo_midia_colaboracao === "video"
      ) {
        const item = document.getElementById(`${this.item.id_colaboracao}`);
        return { width: item.offsetWidth, height: item.offsetHeight };
      }
      return null;
    },
    getMidiaOrientation() {
      if (this.item.url_midia_colaboracao) {
        if (this.item.dsc_tipo_midia_colaboracao === "image") {
          const image = new Image();
          image.src = this.item.url_midia_colaboracao;
          image.onload = () => {
            this.midiaDimension = { width: image.width, height: image.height };
            this.midiaOrientation =
              image.height > image.width ? "vertical" : "horizontal";
          };
        } else if (this.item.dsc_tipo_midia_colaboracao === "video") {
          const createdVideoElement = document.createElement("video");
          createdVideoElement.src = this.item.url_midia_colaboracao;
          createdVideoElement.style.visibility = "hidden";
          document.body.appendChild(createdVideoElement);
          createdVideoElement.addEventListener("loadedmetadata", () => {
            this.midiaDimension = {
              width: createdVideoElement.videoWidth,
              height: createdVideoElement.videoHeight,
            };
            this.midiaOrientation =
              createdVideoElement.videoHeight > createdVideoElement.videoWidth
                ? "vertical"
                : "horizontal";
            document.body.removeChild(createdVideoElement);
          });
        }
      }
    },
  },
  watch: {
    item: function (newValue) {
      if (newValue.url_midia_colaboracao) {
        this.getMidiaOrientation();
        this.divMidiaWrapperDimension = this.getDivMidiaWrapperDimension();
      }
    },
    cardStyle() {
      this.getMidiaOrientation();
      this.divMidiaWrapperDimension = this.getDivMidiaWrapperDimension();
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "Globotipo";
  src: url("@/assets/Globotipo_Regular.otf") format("opentype");
}
header {
  width: 100%;
}

section {
  width: 100%;
}

@media only screen and (max-width: 1367px) and (max-height: 769px) {
  // .colab-text {
  //     font-size: calc(v-bind('bodyTextSize') - .0rem) !important;
  //     line-height: calc(v-bind('lineHeight') - .2rem) !important;
  //     // color: red !important;
  // }
}
</style>
